import React from 'react';
const Card = ({ className='', children, padded=true, ...rest }) => (
  <div className={`card ${padded ? 'p-4 sm:p-6' : ''} ${className}`} {...rest}>{children}</div>
);
export default Card;
